var _a;
import 'reflect-metadata';
import 'wicg-inert';
import moment from 'moment';
// JDS
import '@jobilla/jobilla-design-system/jds.css';
import '@/styles/main.scss';
import JobillaSpaApplication from 'common/JobillaSpaApplication';
import App from './App.vue';
import { JobillaApplication } from 'packages/core/JobillaApplication';
import store from '@/store/core/index';
import DeleteConfirmationModal from '@/app/components/job_lists/DeleteConfirmationModal.vue';
import { QuillScope } from 'packages/core/DeltaRenderer';
import Vue, { nextTick } from 'vue';
import vClickOutside from 'v-click-outside';
import { JobillaDesignSystem } from '@jobilla/jobilla-design-system';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import authMiddleware from './route-middlewares/auth';
import companyInUrlMiddleware from './route-middlewares/company-in-url';
import routes from './routes';
import axios from 'axios';
import { install as initPosthog } from './posthog';
import * as Sentry from '@sentry/vue';
import ENV from 'config/env';
require('moment-duration-format')(moment);
Vue.use(vClickOutside);
Vue.use(JobillaDesignSystem);
initPosthog();
new JobillaApplication().boot({
    quillScope: QuillScope.APP,
    withIntercom: true,
});
var app = new JobillaSpaApplication(false);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
app.appName = 'jobilla';
app.withStore(store);
// Map the admin app to the main app component in index.html
app.registerComponents({
    MainApp: App,
    DeleteJobListConfirmationModal: DeleteConfirmationModal,
});
axios.defaults.baseURL = ENV.JOBILLA_API_ROOT;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';
app.configureRoutes(routes(app));
app.router.beforeEach(authMiddleware(app));
app.router.beforeEach(companyInUrlMiddleware(app));
var urlRegexAllowedSentryNetworkDetails = new RegExp(ENV.JOBILLA_API_ROOT + ".*");
Sentry.init({
    Vue: Vue,
    dsn: 'https://8008ed5f603ad3132dea28071537e902@o4509242152386560.ingest.de.sentry.io/4509254171492432',
    ignoreErrors: ['JdsError'],
    environment: ENV.APP_ENV,
    enabled: ['staging', 'production'].includes(ENV.APP_ENV),
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            networkDetailAllowUrls: [urlRegexAllowedSentryNetworkDetails],
            networkRequestHeaders: ['X-Custom-Header'],
            networkResponseHeaders: ['X-Custom-Header'],
        }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
Sentry.setUser({ id: (_a = app.authenticator.currentUserId) !== null && _a !== void 0 ? _a : null });
if (['staging', 'production'].includes(ENV.APP_ENV)) {
    app.router.afterEach(function (to) {
        nextTick(function () {
            app.router.app.$posthog.capture('$pageview', {
                $current_url: ENV.JOBILLA_URL.replace(/\/$/, '') + "/" + to.fullPath.replace(/^\//, ''),
            });
        });
    });
}
app.start(false);
